import React, { Component } from 'react';
import * as enums from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import VatAggregatePanel from './VatAggregatePanel';
import * as columns from './VatColumns';

class Vat extends Component {

    enrich = (data) => {
        data.bills.map((item) => {
            item.rowType = "VAT";
            item.paymentMethodLabel = enums.getLabel(enums.paymentMethods, item.paymentMethod);
            item.typeLabel = enums.getLabel(enums.billTypes, item.type);
            return item;
        })
        return data.bills;
    }

    render() {
        return (
            <MainTable
                divClassName="vat"
                tableName="Áfa"
                path='/api/vat'
                request={{ 'year': 2021 }}
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                needAggregate={true}
                aggregatePanel={(rows) => <VatAggregatePanel rows={rows} />}/>
        );
    }
}

export default Vat;